import React, { Component } from 'react';

// Componente nuevo: grid de videos de sesiones de Cabildo
// TODO: reemplazar url, thumbnail, titulo y fecha con datos reales

class ResumenCabildo extends Component {
    constructor(props){
        super(props);
        this.state = {
            videos: [
                {
                    id: 1,
                    url: '#',
                    thumbnail: 'assets/images/banner/book.jpg',
                    titulo: 'Sesión de Cabildo — próximamente',
                    fecha: 'Pendiente de publicación'
                },
                {
                    id: 2,
                    url: '#',
                    thumbnail: 'assets/images/banner/book.jpg',
                    titulo: 'Sesión de Cabildo — próximamente',
                    fecha: 'Pendiente de publicación'
                },
                {
                    id: 3,
                    url: '#',
                    thumbnail: 'assets/images/banner/book.jpg',
                    titulo: 'Sesión de Cabildo — próximamente',
                    fecha: 'Pendiente de publicación'
                }
            ]
        }
    }

    render() {
        return (
            <section className="section-padding bg-white" id="videos">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="section-heading center-heading text-center mb-60">
                                <span className="subheading">La Voz en el Cabildo</span>
                                <h3 className="heading-title">Resumen en 1 Minuto</h3>
                                <p>Videos cortos explicando qué se decidió en las últimas sesiones del Ayuntamiento de Mineral de la Reforma.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        {
                            this.state.videos.map((video) => (
                                <div className="col-lg-4 col-md-6 mb-4" key={video.id}>
                                    <div className="video-card">
                                        <a href={video.url} target="_blank" rel="noopener noreferrer" className="video-thumb">
                                            <img src={video.thumbnail} alt={video.titulo} className="img-fluid" />
                                            <span className="video-play-btn">
                                                <i className="fa fa-play-circle"></i>
                                            </span>
                                        </a>
                                        <div className="video-info mt-3">
                                            <h5>{video.titulo}</h5>
                                            <p className="video-fecha">{video.fecha}</p>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </section>
        );
    }
}

export default ResumenCabildo;
